var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doughnut-chart',{style:(_vm.chartStyles),attrs:{"chart-data":_vm.dataCollection,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }